; (function () {
    'use strict';

    var dependencies = ['roomSizeManager', 'constants', 'sizeHelper'];

    var directive = function (roomSizeManager, constants, sizeHelper) {

        return {
            require: ['^validationTooltipMessages', '^ngModel'],
            link: function (scope, elm, attrs, ctrls) {

                var modelCtrl = ctrls[1];
                var toolTipCntrl = ctrls[0];

                var ftErrorMsg = "Error unit! Pattern for input in inches( 25.10\" ), in foot( 25.10 or 25.10'; ), in foot and inches( 25.10'; 25.10\" )";
                var cmErrorMsg = "Error unit! Pattern for input in centimeters( 150.10 )";

                modelCtrl.$validators.unitsValidator = function (value) {

                    var result = sizeHelper.detectSizeUnits(value, roomSizeManager.getCurrentUnits());
                    var msg;

                    if (result !== null && value) {
                        modelCtrl.$setValidity('units', true);
                        return value;
                    }
                    else {

                        msg = roomSizeManager.getCurrentUnits() === constants.SizeUnit.FT ? ftErrorMsg : cmErrorMsg;
                        toolTipCntrl.setMessage('units', msg);
                        modelCtrl.$setValidity('units', false);

                        return value;
                    }
                };
            }
        }

    };

    directive.$inject = dependencies;

    angular.module('valleyCraftApp').directive('unitsValidator', directive);

})();
